// to run this script: tap cmd-shift-1 on keyboard; enter `normalize_crosswalk_direction`
if (!window.custom_scripts) window.custom_scripts = {}
window.custom_scripts.normalize_crosswalk_direction = {
	input_required: false,
	pre_fn: function(input) {
		return new Promise(async (resolve, reject)=>{
			let add_to_log = (s) => { log += `${s}\n` }
			let log = ''

			let leaf_fid = 'fcb1e733-d041-4269-b271-54837bb39557'
			let leaf_fr = vapp.$store.state.framework_records.find(x=>x.lsdoc_identifier == leaf_fid)
			add_to_log(leaf_fr.json.CFDocument.title)
			add_to_log('')

			/////////////////////////////////////////////////////
			// Leaf framework item should always be *destination* 
			/////////////////////////////////////////////////////
			
			// go through all frameworks
			let good_n = 0, bad_n = 0, extra_n = 0
			let fr_processed_n = 0
			for (let fr of vapp.$store.state.framework_records) {
				let doc = fr.json.CFDocument
				// for each crosswalk...
				if (doc.frameworkType == 'crosswalk') {
					// only look at crosswalks with leaf
					if (empty(doc.extensions.crosswalkSourceFrameworkIdentifiers)) {
						add_to_log(`ERROR: no crosswalkSourceFrameworkIdentifiers - ${doc.identifier} / ${doc.title}`)
						continue
					}

					// After the first pass through this script, the script identified the following as frameworks that need adjusting, so now we can just look at them
					if (!['3f225b9d-1452-4944-9b6b-ee88e4e8802d', '7fdb69ea-8166-49f3-bbda-13ca7e07aa29', '61afb020-c2f3-42e1-8476-80d31e1fa2d0', '133eeca8-6143-46ed-8cfe-3011a44dbbd1', '6274c6da-7d9a-431a-8060-e40e6499c8b8', '6299dd84-5896-4ddc-8a2f-d21b4df9b14d', 'c7d4a9d3-875d-4c4d-b4af-d99af8353011'].includes(doc.identifier)) {
						continue
					}

					let s = ''
					// if LEAF is listed as the origin, that's probably bad
					if (doc.extensions.crosswalkSourceFrameworkIdentifiers[0] == leaf_fid) {
						s = `LEAF is O (bad): ${doc.title.replace(/.*?<-> “(.*)”.*/, '$1')}`
						++bad_n
					} else {
						// if LEAF is listed as the destination, that's probably good
						if (doc.extensions.crosswalkSourceFrameworkIdentifiers[1] == leaf_fid) {
							s = `LEAF is D: ${doc.title.replace(/Crosswalk: (.*?) <->.*/, '$1')}`
							++good_n
						} else {
							// add_to_log(`LEAF is not involved: ${doc.title}`)
							++extra_n
							continue
						}
					}

					// retrieve the framework
					U.loading_start()
					await U.load_framework_and_cfo(doc.identifier)
					U.loading_stop()

					// go through all assocs
					let assocs_data = []
					let good_a = 0, bad_a = 0, extra_a = 0
					for (let assoc of fr.json.CFAssociations) {
						// console.warn(object_copy(assoc))
						// resolve(log)
						// return

						let o_fid = assoc.originNodeURI.title.replace(/[\s\S]*\(:(\S+):\)\s*$/, '$1')
						let d_fid = assoc.destinationNodeURI.title.replace(/[\s\S]*\(:(\S+):\)\s*$/, '$1')

						// if LEAF is d_fid, OK
						if (d_fid == leaf_fid) {
							++good_a
						} else {
							// ****** else if LEAF is o_fid, bad
							if (o_fid == leaf_fid) {
								++bad_a
								// copy and add toassocs_data
								assoc = object_copy(assoc)
								let x = assoc.originNodeURI
								assoc.originNodeURI = assoc.destinationNodeURI
								assoc.destinationNodeURI = x
								assoc.lastChangeDateTime = '*NOW*'
								assocs_data.push(assoc)
								// break

							} else {
								// else not relevant
								++extra_a
								console.warn(o_fid, d_fid, object_copy(assoc))
							}
						}
					}

					// if we found any reversed assocs, save
					if (bad_a > 0) {
						let data = {
							check_out_and_in: 'yes',
							lsdoc_identifier: doc.identifier,
							CFAssociations: assocs_data,
						}
						console.warn(data)
						// UNCOMMENT THESE LINES TO SAVE
						// await vapp.$store.dispatch('save_framework_data', data)
						// console.warn('SAVED!')
					}

					let result = (bad_a > 0) ? 'XX' : '  '
					add_to_log(`${result} G: ${good_a} / B: ${bad_a} / O: ${extra_a} -- ${doc.identifier} ${s}`)

					// if (bad_a > 0) break

					// only process the first X crosswalks -- a total of 76 need to be processed (as of 11/6/2025)
					++fr_processed_n
					if (fr_processed_n >= 90) break
				}
			}

			add_to_log('')
			add_to_log(`LEAF is destination (good): ${good_n} / LEAF is destination (bad): ${bad_n} / LEAF is neither: ${extra_n}`)

			resolve(log)
		})
	},

}